import type { LayoutSnapshot } from '@server/trading-layouts/schemas';
import type { DraftFormState } from '@client/state/draft-form-state.hook';
import { sanitizeTradingFormState } from '@client/state/form-state-sanitizer';
import { formStateToLayoutState } from './layout-template-state.utils';

export const buildLayoutSnapshot = (
  draftState: DraftFormState
): LayoutSnapshot => {
  if (!draftState) {
    throw new Error('Draft state is required');
  }

  return {
    version: 1,
    formState: formStateToLayoutState(sanitizeTradingFormState(draftState))
  };
};
